import { fetchVideoData, fetchGalleryVideos } from "../actions/index";
import {
  galleryVideosReducer,
  VideoReducer,
  uploadVideoReducer,
  updateVideoReducer,
  deleteVideoReducer,
} from "./reducer";

const videoGalleryReducers = {
  galleryVideoGlobalStore: galleryVideosReducer,
  videoGlobalStore: VideoReducer,
  uploadVideoGlobalStore: uploadVideoReducer,
  updateVideoGlobalStore: updateVideoReducer,
  deleteVideoGlobalStore: deleteVideoReducer,
};

export { fetchVideoData, fetchGalleryVideos, videoGalleryReducers };
